import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';
import { TModalType } from '../types';

export function useMicrofrontEvents(
  manifest: IMicrofrontendManifest | undefined,
  loadingModalTypeSetter: (type: TModalType | null) => void,
) {
  const { eventQueue } = useApplicationContext();

  const handleInitialLoadingStart = React.useCallback(
    () => loadingModalTypeSetter('selfRequestModal'),
    [loadingModalTypeSetter],
  );

  const handleInitialLoadingEnd = React.useCallback(() => loadingModalTypeSetter(null), [loadingModalTypeSetter]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
      handleInitialLoadingStart,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::start',
        handleInitialLoadingStart,
      );
  }, [eventQueue, handleInitialLoadingStart, manifest]);

  React.useEffect(() => {
    if (!manifest) {
      return;
    }

    eventQueue.on(
      'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
      handleInitialLoadingEnd,
    );

    return () =>
      eventQueue.off(
        'newbuilding-broker-modals-micro-frontend-reporting.v1.self-request-modal-initial-loading::end',
        handleInitialLoadingEnd,
      );
  }, [eventQueue, handleInitialLoadingEnd, manifest]);
}
